module.exports = __webpack_public_path__ + "static/media/twitter-fill (2)@2x.20f35710.svg";